import ThemeProvider from 'components/latest-core/ThemeProvider';
import ResellerOnboarding from './ResellerOnboarding';
import { useContext } from 'react';
import { HotelContext } from 'utilities/Context';
import { StyledEngineProvider } from '@mui/styled-engine';

const ResellerMain = () => {
  const {
    currentHotel: { hotelcode: hotelCode },
  } = useContext(HotelContext);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider>
        <ResellerOnboarding key={hotelCode} />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default ResellerMain;
